import React from 'react';
import {
  StyledPhone,
  StyledPhoneNumber,
  StyledWrapper,
  StyledPhoneIcon,
  StyledChats,
  StyledLink,
  StyledPopupTooltip, StyledPopupContent, StyledOtherChats,
} from "./PhoneChatsStyle";
import { ReactComponent as Phone } from "../../assets/svg/phone.svg";
import { ChatLinks, PHONE_NUMBER } from "./constants";

const renderArrayOfChats = (array, startIndex = 0) =>
  array.map(({ Icon, link, tooltip, id: chatId, onClick }, index) =>
    <StyledPopupTooltip
      key={chatId}
      trigger={() =>
        <StyledLink target="_blank" style={{ left: - ((index + startIndex)*8) }} href={link} id={chatId} onClick={(e) => {
          e.stopPropagation();
          if (onClick) {
            e.preventDefault();
            onClick();
          }
        }
        }>
          <Icon />
        </StyledLink>
      }
      position="bottom center"
      on={["hover"]}
    >
      <StyledPopupContent>
        {tooltip}
      </StyledPopupContent>
    </StyledPopupTooltip>
  )

const PhoneChatsHeader = () => {
  return (
    <StyledWrapper>
      <StyledPhone>
        <StyledPhoneIcon >
          <Phone />
        </StyledPhoneIcon>
        <StyledPhoneNumber>
          {PHONE_NUMBER}
        </StyledPhoneNumber>
      </StyledPhone>
      <StyledChats>
        {renderArrayOfChats(ChatLinks.slice(0, 2))}
        <StyledOtherChats>
          {renderArrayOfChats(ChatLinks.slice(2), 2)}
        </StyledOtherChats>
      </StyledChats>
    </StyledWrapper>
  )
}

export { PhoneChatsHeader };